import "bobjoll/ts/library/common";
import popup from "Library/popup";

export default class Share {
  private static method(
    network: string,
    image: string,
    url: string,
    title: string,
    tags: string,
    summary: string
  ) {
    const message = `Hey! Have a look at this awesome article I have found: ${url}`;
    const networks: { [name: string]: string } = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      google: `https://plus.google.com/share?url=${url}`,
      linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${url}&source=${SITE_URL}&title=${title}&summary=${summary}`,
      pinterest: `http://pinterest.com/pin/create/button/?url=${url}&media=${image}&description=${summary}`,
      telegram: `https://telegram.me/share/url?url=${url}&text=${message}`,
      twitter: `https://twitter.com/share?text=${title}&url=${url}&hashtags=${tags}`,
      whatsapp: `https://wa.me/?text=${message}`
    };

    return networks[network];
  }

  public static url(this: HTMLElement) {
    const share = <HTMLElement | null>this.parent("[data-share-url]");
    const metas = (this.dataset.metas || "").split(",");
    const metaTags = ["FreepikCompany", ...metas]
      .map(tag => `%23${tag}`)
      .join(" ");

    if (share) {
      let image = encodeURI(share.dataset.shareImage || "");
      let network = encodeURI(this.dataset.network || "");
      let summary = encodeURI(share.dataset.shareSummary || "");
      let tags = encodeURI(share.dataset.shareTags || "");
      let title = encodeURI(share.dataset.shareTitle || "");
      let url = encodeURI(share.dataset.shareUrl || "");

      if (metaTags.length) {
        summary += `${title} ${metaTags}`;
        title += ` ${metaTags}`;
      }

      const networkUrl = Share.method(
        network,
        image,
        url,
        title,
        tags,
        summary
      );

      if (network.match(/whatsapp|telegram/)) {
        window.open(networkUrl);
      } else {
        popup(networkUrl, 640, 480);
      }
    }
  }
}
